export default function ConstructionProjects() {
  const projects = [
    {
      id: 1,
      title: 'Skyline Residences',
      category: 'Residential Complex',
      status: 'Completed',
      year: '2023',
      description: 'A 25-story luxury residential tower featuring 180 premium apartments with state-of-the-art amenities and panoramic city views.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20modern%20residential%20tower%20construction%20project%2C%20tall%20luxury%20apartment%20building%20with%20contemporary%20glass%20and%20steel%20architecture%2C%20urban%20skyline%20setting%20with%20professional%20construction%20photography%2C%20finished%20high-rise%20development%20showcasing%20architectural%20achievement%2C%20clear%20blue%20sky%20background%2C%20premium%20residential%20real%20estate%20project%20completion&width=900&height=600&seq=construction-skyline-1&orientation=landscape',
      stats: { units: '180', floors: '25', area: '250,000 sqft' }
    },
    {
      id: 2,
      title: 'Corporate Plaza',
      category: 'Commercial Development',
      status: 'Completed',
      year: '2022',
      description: 'Modern commercial complex with Grade-A office spaces, retail outlets, and premium facilities designed for corporate excellence.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20office%20building%20construction%20completed%2C%20contemporary%20corporate%20plaza%20with%20sleek%20glass%20facade%2C%20professional%20business%20architecture%20in%20urban%20setting%2C%20finished%20commercial%20development%20project%2C%20sophisticated%20office%20complex%20with%20retail%20spaces%2C%20daytime%20photography%20showing%20architectural%20excellence%20and%20quality%20construction&width=900&height=600&seq=construction-corporate-1&orientation=landscape',
      stats: { units: '45', floors: '18', area: '320,000 sqft' }
    },
    {
      id: 3,
      title: 'Green Valley Estates',
      category: 'Gated Community',
      status: 'In Progress',
      year: '2024',
      description: 'Exclusive gated community featuring 120 luxury villas with world-class amenities, landscaped gardens, and sustainable design.',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20gated%20community%20under%20construction%2C%20residential%20development%20project%20with%20modern%20villas%20being%20built%2C%20construction%20site%20showing%20progress%20on%20upscale%20housing%20estate%2C%20professional%20development%20photography%2C%20organized%20construction%20environment%20with%20quality%20materials%2C%20suburban%20location%20with%20planned%20landscaping%20and%20infrastructure%20development&width=900&height=600&seq=construction-greenvalley-1&orientation=landscape',
      stats: { units: '120', floors: '2-3', area: '450,000 sqft' }
    },
    {
      id: 4,
      title: 'Metro Shopping Mall',
      category: 'Retail Complex',
      status: 'In Progress',
      year: '2024',
      description: 'Large-scale retail and entertainment destination with 200+ stores, multiplex cinema, and food court spanning multiple levels.',
      image: 'https://readdy.ai/api/search-image?query=Large%20shopping%20mall%20construction%20in%20progress%2C%20modern%20retail%20complex%20being%20built%20with%20contemporary%20architecture%2C%20construction%20site%20showing%20steel%20framework%20and%20structure%2C%20professional%20construction%20photography%20of%20commercial%20development%2C%20urban%20retail%20project%20under%20development%2C%20organized%20building%20site%20with%20quality%20construction%20standards&width=900&height=600&seq=construction-metro-mall-1&orientation=landscape',
      stats: { units: '200+', floors: '5', area: '580,000 sqft' }
    }
  ];

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="projects" className="py-32 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-6 bg-blue-500/10 border border-blue-500/20 px-5 py-2 rounded-full">
            <div className="w-2 h-2 bg-blue-600 rounded-full" />
            <span className="text-blue-700 font-semibold text-sm tracking-wider uppercase">Construction Projects</span>
          </div>
          
          <h3 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Building the{' '}
            <span className="bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">
              Future Today
            </span>
          </h3>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore our portfolio of exceptional construction projects that showcase our commitment to quality, innovation, and timely delivery across residential, commercial, and mixed-use developments.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid lg:grid-cols-2 gap-8 mb-20">
          {projects.map((project) => (
            <div 
              key={project.id}
              onClick={scrollToContact}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-blue-500/30 cursor-pointer"
            >
              {/* Image */}
              <div className="relative overflow-hidden h-80">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                
                {/* Status Badge */}
                <div className="absolute top-5 right-5">
                  <span className={`px-5 py-2 rounded-full text-xs font-bold shadow-lg ${
                    project.status === 'Completed' 
                      ? 'bg-gradient-to-r from-green-500 to-green-600 text-white' 
                      : 'bg-gradient-to-r from-red-600 to-blue-600 text-white'
                  }`}>
                    {project.status}
                  </span>
                </div>
                
                {/* Title Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-7">
                  <div className="text-blue-400 text-sm font-semibold mb-2 flex items-center gap-2">
                    <i className="ri-building-line"></i>
                    {project.category}
                  </div>
                  <h4 className="text-3xl font-bold text-white leading-tight">{project.title}</h4>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <p className="text-gray-600 mb-8 leading-relaxed text-lg">{project.description}</p>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-6 mb-8 pb-8 border-b border-gray-200">
                  <div className="text-center">
                    <div className="text-3xl font-bold bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent mb-2">
                      {project.stats.units}
                    </div>
                    <div className="text-xs text-gray-500 uppercase font-semibold tracking-wider">Units</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent mb-2">
                      {project.stats.floors}
                    </div>
                    <div className="text-xs text-gray-500 uppercase font-semibold tracking-wider">Floors</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent mb-2">
                      {project.stats.area}
                    </div>
                    <div className="text-xs text-gray-500 uppercase font-semibold tracking-wider">Total Area</div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <i className="ri-calendar-line text-blue-600"></i>
                    <span className="font-medium">Completed: {project.year}</span>
                  </div>
                  <button className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-bold group-hover:gap-4 transition-all cursor-pointer whitespace-nowrap">
                    View Details
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="relative bg-gradient-to-br from-gray-900 via-black to-gray-800 rounded-3xl p-16 text-center overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-500/10 rounded-full blur-3xl" />
          
          <div className="relative">
            <div className="inline-flex items-center gap-2 mb-6 bg-blue-500/20 border border-blue-500/30 px-5 py-2 rounded-full">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" />
              <span className="text-blue-400 font-semibold text-sm tracking-wider uppercase">Start Your Project</span>
            </div>
            
            <h4 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Have a Project in Mind?
            </h4>
            
            <p className="text-gray-300 text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
              Let's discuss how Madina Associates can bring your construction vision to life with our expertise and commitment to excellence.
            </p>
            
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="group bg-gradient-to-r from-red-600 to-blue-600 text-white px-12 py-5 rounded-xl hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 font-bold text-lg whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center justify-center gap-2">
                Start Your Project Today
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
